<template>
  <div id="footer" class="footer">
    <div class="top">
      <div class="left">
        <img class="qrcode" :src="qrsales" />
        <p class="scan" v-show="false">{{ $t('footer.static.qrsales.label') }}</p>
      </div>
      <div class="right">
        <p class="contact">{{ $t('footer.static.contact.label') }}</p>
        <template v-for="(contact, index) in contacts">
          <div class="item" :key="index">
            <i :class="contact.icon" />
            <p>{{ contact.label }}</p>
          </div>
        </template>
      </div>
    </div>
    <div class="bottom">
      <p class="copyright">{{ $t('footer.static.copyright.label') }}</p>
      <a class="beian" :href="beian.url" target="blank">{{ beian.id }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: [
        { prop: 'phone', label: this.$t('footer.static.contact.phone'), icon: 'el-icon-phone-outline' },
        { prop: 'mail', label: this.$t('footer.static.contact.mail'), icon: 'el-icon-message' }
      ],
      beian: {
        url: 'https://beian.miit.gov.cn/',
        id: '粤ICP备10201584号'
      }
    }
  },
  computed: {
    qrsales: function() {
      return require('@/assets/qrcode.sales.png')
    },
    qrpubacc: function() {
      return require('@/assets/qrcode.pubacc.png')
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  height: 100%;
  padding: 1rem 2rem;
  background: #171f25;
  color: #798893;

  display: flex;
  flex-direction: column;
}

.footer .top {
  width: 100%;

  display: flex;
  flex-direction: row;
}
.footer .bottom {
  width: 100%;

  display: flex;
  flex-direction: column;
}

.top .left {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
}
.top .right {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.left .qrcode {
  width: 10rem;
  height: 10rem;
}
.left .scan {
  font-size: 1.4rem;
  writing-mode: vertical-lr;
}

.bottom .copyright {
  font-size: 1.4rem;
}
.bottom .beian {
  font-size: 1rem;
}

.right .contact {
  padding-bottom: 0.6rem;
  font-size: 1.4rem;
}
.right .item {
  padding: 0.2rem;
  font-size: 1.2rem;
}
</style>
